export const isProduction = () =>
  window.location.origin === 'https://app.teamculture.com.br'

export default {
  isProduction,
}
